import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import LoaderComponent from '../common/LoaderComponent';
import { SavingPots } from './SavingPots';
import { SavingPotsRejig } from './SavingPotsRejig';
import { CreateSavingsPot } from './CreateSavingsPot';
import { SavingPotDetail } from './SavingPotDetail';
import { ReducePot } from './ReducePot';
import { SavingPotConfirmation } from './SavingPotConfirmation';
import AccountsStore from '../../stores/AccountsStore';
import SiteHeader from '../../includes/SiteHeader';

import { BasicModal } from '../common/modals/BasicModal';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import AnyQuestions from '../help/AnyQuestions';
import BrowserUtils from '../../utils/BrowserUtils';
import SavingsPotsStore from '../../stores/SavingsPotsStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import MobileOverlay from '../common/MobileOverlay';

let savingsPotContent;

/**
 * @todo
 * The quality of this component has been assessed to be Low,
 * and requires refactoring in order to meet a standard of best practice.
 */
class SavingPotsLanding extends Component {
  constructor(props) {
    super(props);

    this.getHeaderClass = this.getHeaderClass.bind(this);
    this.alertPotErrorModal = this.alertPotErrorModal.bind(this);
    this.closeAlertModal = this.closeAlertModal.bind(this);
    this.getAccountListPage = this.getAccountListPage.bind(this);
    this.getCreateSavingPot = this.getCreateSavingPot.bind(this);
    this.getPotPageMobile = this.getPotPageMobile.bind(this);
    this.closeFaq = this.closeFaq.bind(this);
    this.goBackToSavingsPotTile = this.goBackToSavingsPotTile.bind(this);
    this.openFaq = this.goBackToSavingsPotTile.bind(this);

    this.state = {
      potErrorModal: !isEmpty(this.props.potError),
      faqFlag: false,
    };
  }

  getHeaderClass(e) {
    this.setState({ headerClass: e });
  }

  alertPotErrorModal() {
    if (this.state.potErrorModal) {
      return (
        <BasicModal>
          <div className="modal_content">
            <h3>{this.props.potError.error.message}</h3>
            <p>
              {this.props.content.potSupportMessage1}
              <br />
              {this.props.content.potSupportMessage2}
              <br />
              {this.props.potError.error.quoteId}
            </p>
          </div>
          <div className="modal_footer">
            <button onClick={this.closeAlertModal}>
              {this.props.content.ok}
            </button>
          </div>
        </BasicModal>
      );
    } else {
      return false;
    }
  }

  closeAlertModal() {
    this.setState({ potErrorModal: false });
    SavingPotsActionCreator.closetErrorModal();
  }

  getAccountListPage() {
    SavingsPotsStore.setCheckActiveFlag(false);
  }

  getCreateSavingPot() {
    SavingPotsActionCreator.getCreateSavingPotPage();
  }

  getPotPageMobile() {
    SavingPotsActionCreator.getPotData();
  }

  closeFaq() {
    this.setState({ faqFlag: false });
  }

  goBackToSavingsPotTile(e) {
    e.preventDefault();
    InternetBankingActions.navigateToWebTask(
      SavingsPotsStore.getNavigationReference()
    );
  }

  openFaq() {
    this.setState({ faqFlag: true });
  }

  render() {
    let content = this.props.content;
    const pots = this.props.pots.pots;
    const reducePotData = this.props.reducePotData;
    const accountClass = `account-${this.props.accountIndex}`;
    const accDetails = AccountsStore.getAccountDetail(
      this.props.getSelectedAccountID
    );
    const potError = this.props.potError;
    const checkActiveFlag = SavingsPotsStore.checkActiveFlag();
    let spContent;
    let unallocatedAmount;
    let headerContent;
    let bodyContent;
    let defaultMobileOverlay;
    let rejigCheck = false;
    let clickedAccountName;
    const data = this.props.getClickedAccount;
    let fromTop = '';
    if (data && data.metadata) {
      clickedAccountName = data.displayName;
    }

    if (pots) {
      unallocatedAmount = this.props.pots.unAllocatedData || 0;
    }
    if (this.props.getPotConfirmation) {
      savingsPotContent = (
        <SavingPotConfirmation
          accountClass={accountClass}
          getSelectedAccountID={this.props.getSelectedAccountID}
          getPotPageHandleClick={this.props.getPotPageHandleClick}
          content={content}
        />
      );
    } else if (reducePotData.length > 0) {
      savingsPotContent = (
        <ReducePot
          interPotError={this.props.interPotError}
          accountClass={accountClass}
          getSelectedAccountID={this.props.getSelectedAccountID}
          content={content}
          pots={reducePotData}
          getFull={this.props.pots}
          getPotPageHandleClick={this.props.getPotPageHandleClick}
          accDetails={accDetails}
        />
      );
    } else if (this.props.potDetailFlag) {
      savingsPotContent = (
        <SavingPotDetail
          accountClass={accountClass}
          getSelectedAccountID={this.props.getSelectedAccountID}
          content={content}
          potDetailsData={this.props.potDetailsData}
          getPotPageHandleClick={this.props.getPotPageHandleClick}
          getPotPageMobile={this.getPotPageMobile}
        />
      );
    } else if (this.props.createSavingPotFlag) {
      savingsPotContent = (
        <CreateSavingsPot
          editError={this.props.editError}
          accountClass={accountClass}
          getSelectedAccountID={this.props.getSelectedAccountID}
          pots={pots}
          content={content}
          potDetailsData={this.props.potDetailsData}
          getPotPageHandleClick={this.props.getPotPageHandleClick}
        />
      );
    } else {
      if (this.props.unavailableCheck) {
        spContent = (
          <div className="saving_pot_list__wrapper">
            <div className="saving_pot_list">
              <div className="valign-center">
                {content.savingpotscurrentlyunavailable1}
                <br />
                {content.savingpotscurrentlyunavailable2}
              </div>
            </div>
          </div>
        );
      } else if (pots) {
        if (unallocatedAmount < 0) {
          rejigCheck = true;
          spContent = (
            <SavingPotsRejig
              getSelectedAccountID={this.props.getSelectedAccountID}
              content={content}
              pots={pots}
              unallocatedAmount={unallocatedAmount}
            />
          );
        } else {
          spContent = (
            <SavingPots
              pots={pots}
              unallocatedAmount={unallocatedAmount}
              content={content}
              getSelectedAccountID={this.props.getSelectedAccountID}
            />
          );
        }
      } else if (!isEmpty(potError)) {
        spContent = '';
      } else {
        spContent = <LoaderComponent type={'large'} />;
      }

      defaultMobileOverlay = (
        <MobileOverlay
          getHeaderClass={this.getHeaderClass}
          selectedTab="savingpots"
          content={this.props.content}
          openFaq={this.openFaq}
        />
      );
      if (BrowserUtils.isMobileView()) {
        if (!checkActiveFlag) {
          fromTop = '';
          headerContent = '';
          bodyContent = (
            <div className="col-md-4 col-sm-4 col-xs-12">
              <h3 className="panel-title">{content.savingpotTitle}</h3>
              {defaultMobileOverlay}
              <div className="account--list">{this.props.accountList}</div>
            </div>
          );
        } else {
          fromTop = 'from-top';
          headerContent = (
            <div
              className={`text-left inner-header row no-gutters ${accountClass}`}
            >
              <div className="col-xs-3 text-left">
                <button className="page-back" onClick={this.getAccountListPage}>
                  <span className="icon icon-page-back" />
                  {content.back}
                </button>
              </div>
              <div className="col-xs-6 inner-header-title text-center">
                {clickedAccountName}
              </div>
              <div className="col-xs-3" />
            </div>
          );

          if (!rejigCheck) {
            defaultMobileOverlay = (
              <MobileOverlay
                getHeaderClass={this.getHeaderClass}
                selectedTab="savingpotslist"
                content={this.props.content}
                openFaq={this.openFaq}
                getCreateSavingPot={this.getCreateSavingPot}
              />
            );
          }
          bodyContent = (
            <div className="col-md-8 col-sm-8 col-xs-12">
              <div className="savingPotsRight">
                <h3 className="panel-title">{content.savingpotTitle}</h3>
                {defaultMobileOverlay}
                {spContent}
              </div>
            </div>
          );
        }

        savingsPotContent = (
          <div>
            {headerContent}
            <div className={`main-container ${fromTop}`}>
              <div className="scroll-wrapper">
                <div className="row saving-pots content-wrapper">
                  <div className={`potPage sp ${accountClass}`}>
                    {bodyContent}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        savingsPotContent = (
          <div>
            <div className="main-container">
              <div className="step-back-savings">
                <a
                  href="javascript:void(0)"
                  className="page-back"
                  onClick={this.goBackToSavingsPotTile}
                >
                  <span className="icon icon-page-back" />
                  {this.props.content.back}
                </a>
              </div>
              <div className="row saving-pots content-wrapper">
                <div className="clearfix" />
                <div className={`potPage sp ${accountClass}`}>
                  <div className="col-md-4 col-sm-4 col-xs-12">
                    <h3 className="panel-title">
                      {content.savingpotAccountTitle}
                    </h3>
                    <div className="account--list">
                      {this.props.accountList}
                    </div>
                  </div>
                  <div className="col-md-8 col-sm-8 col-xs-12">
                    <div className="savingPotsRight">
                      <h3 className="panel-title">{content.savingpotTitle}</h3>
                      {spContent}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }
    }
    return this.state.faqFlag ? (
      <div>
        <SiteHeader />
        <AnyQuestions {...this.props} closed={this.closeFaq} />
      </div>
    ) : (
      <div className="full-height">
        {this.props.unavailableCheck ? '' : this.alertPotErrorModal()}
        {savingsPotContent}
      </div>
    );
  }
}

SavingPotsLanding.propTypes = {
  accountList: PropTypes.object,
  pots: PropTypes.any.isRequired,
  potDetailsData: PropTypes.object,
  createSavingPotFlag: PropTypes.any.isRequired,
  getPotConfirmation: PropTypes.any.isRequired,
  createSavingPotHandleClick: PropTypes.func,
  getPotPageHandleClick: PropTypes.func,
  potDetailFlag: PropTypes.any.isRequired,
  reducePotData: PropTypes.array,
  content: PropTypes.object,
  getSelectedAccountID: PropTypes.string,
  accountIndex: PropTypes.number,
  editError: PropTypes.object,
  potError: PropTypes.object,
  interPotError: PropTypes.object,
  unavailableCheck: PropTypes.any.isRequired,
  getClickedAccount: PropTypes.array,
};

export { SavingPotsLanding };
